export const createA11yOutlineStyles = (theme, style = 'auto', improvedVisibility) => `outline: ${improvedVisibility ? theme.size.border.bulky : theme.size.border.heavy} ${style} ${theme.colors.focus.main};`;
